import { CheckCircle } from "@mui/icons-material"
import { Box, Typography } from "@mui/material"
import { Stack } from "@mui/material"
import { useState, useEffect } from "react"
import ReactPlayer from "react-player/youtube"
import { Link, useParams } from "react-router-dom"
import { fetchFromAPI } from '../utils/fetchFromAPI'
import Videos from './Videos'

const VideoDetail = () => {
  const [videoDetail, setVideoDetail] = useState(null)
  const [videos, setVideos] = useState([])
  const { id } = useParams()
  // console.log(videoDetail, videos)

  useEffect(() => {
    fetchFromAPI(`videos?part=snippet,statistics&id=${id}`)
      .then((data) => setVideoDetail(data.items[0]))
    fetchFromAPI(`search?part=snippet&relatedToVideoId${id}&type=video`)
      .then((data) => setVideos(data.items))
  }, [id])


  if(!videoDetail?.snippet) return 'Loading...'

  const { snippet: { title, channelId, channelTitle }, statistics: { viewCount, likeCount } } = videoDetail

  return (
    <Box minHeight="95vh">
      <Stack direction={{ xs: 'column', md: 'row' }}>
        <Box flex={1}>
          <Box sx={{ width: '100%', position: 'sticky', top: '86px' }}>
            <ReactPlayer width="100%" height="60vh" controls={true} url={`https://www.youtube.com/watch?v=${id}`} />
            <Typography color="#fff" variant="h5" fontWeight="bold" fontSize={{ xs: '20px', sm: '24px', md: '24px' }} p={2} >
              {title}
            </Typography>
            <Stack direction="row" justifyContent="space-between" sx={{ color: "#fff"}} py={1} px={2}>
              <Link to={`/channel/${channelId}`}>
                <Typography variant='subtitle1' sx={{ color: "#fff", fontWeight: 'bold'}}>
                  {channelTitle}
                  <CheckCircle sx={{ fontSize: '12px', color: 'gray', ml: '5px'}} />
                </Typography>
              </Link>
              <Stack direction="row" gap="20px" alignItems="center">
                <Typography variant="body1" sx={{ opacity: 0.7 }}>
                  {parseInt(viewCount).toLocaleString()} views
                </Typography>
                <Typography variant="body1" sx={{ opacity: 0.7 }}>
                  {parseInt(likeCount).toLocaleString()} likes
                </Typography>
              </Stack>
            </Stack>
          </Box>
        </Box>

        <Box px={2} py={{md: 1, xs: 5}} justifyContent='center' alignItems='center'>
          <Videos videos={videos} direction="coulumn" />
        </Box>

      </Stack>
    </Box>
  )
}

export default VideoDetail